module.exports = __webpack_public_path__ + "img/v3-angledown.3819eda8.svg";